var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 75C58.7107 75 75.5 58.2107 75.5 37.5C75.5 16.7893 58.7107 0 38 0C17.2893 0 0.5 16.7893 0.5 37.5C0.5 58.2107 17.2893 75 38 75Z",
    fill: "#273B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.75 13.5C24.275 13.5 12.5 23.325 12.5 35.4C12.5 41.4 14.375 45.15 19.1 49.05L15.575 59.25C15.575 59.25 15.125 60.075 15.65 60.6C16.1 61.125 17.075 60.75 17.075 60.75L29.45 55.8C32.375 56.775 35.525 57.3 38.9 57.3C53.375 57.3 65.15 47.475 65.15 35.4C65 23.25 53.225 13.5 38.75 13.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.05 46.575C36.05 45 37.325 43.65 38.975 43.65C40.55 43.65 41.9 45 41.9 46.575C41.9 48.15 40.55 49.5 38.975 49.5C37.325 49.5 36.05 48.15 36.05 46.575ZM37.025 40.5L36.2 21H41.6L40.85 40.5H37.025Z",
    fill: "#007FBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispute);
export default __webpack_public_path__ + "static/media/Dispute.b9b03fd08b0d9bc8dc418423bab7d344.svg";
export { ForwardRef as ReactComponent };